import { Loader, Application, Sprite, Texture } from 'pixi.js';
import { gsap } from 'gsap';
import { debounce } from "../../utils";

class HeroZoneGenius {
    constructor(el) {
        this.el = el;
        this.setSizes();
        this.init();
    }

    init() {
        this.app = new Application({
            width: this.elWidth,
            height: this.elHeight,
            backgroundColor: 0x000000,
            backgroundAlpha: 0,
            resolution: 2,
            autoResize:true,
            antialias: true,
        });

        this.el.appendChild(this.app.view);
        this.loadImages();
        window.addEventListener('resize', debounce(this.resizeHandler.bind(this), 100));
    }

    resizeHandler() {
        const previousWidth = this.elWidth;
        this.setSizes();
        if (previousWidth !== this.elWidth) {
            this.resize();
        }
    }

    loadImages() {
        const loader = new Loader();
        loader.add('maskImage', `${window.assets_url}/images/patterns/hero-topo-pattern-zone-genius.svg`);
        loader.load((loader, resources) => {
            this.onImagesLoaded(resources);
        });
    }

    onImagesLoaded(resources) {
        this.pattern = new Sprite(resources.maskImage.texture);
        this.pattern.originalWidth = this.pattern.width;
        this.pattern.originalHeight = this.pattern.height;

        this.applyObjectFitRightHeight(this.pattern);

        this.app.stage.addChild(this.pattern);

        this.createDiagonalMask(this.pattern);
    }

    alphaValue(t) {
        return Math.pow(Math.sin(Math.PI * t), 3);
    }

    createDiagonalMask(maskSprite) {
        this.maskCanvas = document.createElement('canvas');
        this.maskWidth = this.elWidth * 2;
        this.maskHeight = this.elHeight * 2;
        this.maskCanvas.width = this.maskWidth;
        this.maskCanvas.height = this.maskHeight;

        const ctx = this.maskCanvas.getContext('2d');
        const gradient = ctx.createLinearGradient(0, this.maskHeight, this.maskWidth, 0);
        for (let t = 0; t <= 1; t += 0.01) {
            let alpha = this.alphaValue(t);

            gradient.addColorStop(t, 'rgba(116, 0, 233, ' + alpha + ')');
        }

        ctx.fillStyle = gradient;
        ctx.fillRect(0, 0, this.maskWidth, this.maskHeight);

        const maskTexture = Texture.from(this.maskCanvas);
        this.mask = new Sprite(maskTexture);
        this.mask.x = -this.maskWidth;
        this.mask.width = this.maskWidth;
        this.mask.height = this.maskHeight;

        this.mask.mask = maskSprite;
        this.app.stage.addChild(this.mask);

        gsap.to("#mask-zone-logo, #mask-zone-logo-2, #mask-zone-logo-3", {opacity: 1, duration: 2, stagger: 0.15})

        gsap.fromTo(this.mask, { x: -this.maskWidth }, { x: 0, duration: 5, ease: 'power2.inOut',
            onStart: () => {
                setTimeout(() => {
                    gsap.to("#zone-genius-logo-blink", { x: "+= 3500", duration: 3, ease: 'none', force3D:false });
                }, 2000);
            }
        });
    }

    updateMaskCanvasSize() {
        if (this.maskCanvas) {
            this.maskWidth = this.elWidth * 2;
            this.maskHeight = this.elHeight * 2;
            this.maskCanvas.width = this.maskWidth;
            this.maskCanvas.height = this.maskHeight;
            const ctx = this.maskCanvas.getContext('2d');
            const gradient = ctx.createLinearGradient(0, this.maskHeight, this.maskWidth, 0);
            for (let t = 0; t <= 1; t += 0.01) {
                let alpha = this.alphaValue(t);

                gradient.addColorStop(t, 'rgba(116, 0, 233, ' + alpha + ')');
            }

            ctx.fillStyle = gradient;
            ctx.fillRect(0, 0, this.maskWidth, this.maskHeight);

            this.mask.texture = Texture.from(this.maskCanvas);
            this.mask.x = 0;
            this.mask.width = this.maskWidth;
            this.mask.height = this.maskHeight;
        }
    }

    applyObjectFitRightHeight(sprite) {
        const scale = this.elHeight / sprite.originalHeight;

        sprite.scale.set(scale);
        sprite.x = this.elWidth - sprite.width;
        sprite.y = 0;
    }

    resize() {
        this.app.renderer.resize(this.elWidth, this.elHeight);
        if (this.pattern) {
            this.applyObjectFitRightHeight(this.pattern);
            this.updateMaskCanvasSize();
        }
    }

    setSizes() {
        this.elWidth = this.el.offsetWidth;
        this.elHeight = this.el.offsetHeight;
    }
}


export default HeroZoneGenius
